import { authSelector } from "@redux/auth/reducer";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export const RedirectAuth = ({}) => {
    const router = useRouter()
    const auth = useSelector(authSelector)

    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
    }
    if(
        auth?.userData?._id && 
        !auth?.isAuth && 
        // process.browser && 
        router?.asPath != '/register' &&
        router?.asPath != '/login' &&
        typeof window !== 'undefined'
    ) {
        // router.push('/login');
        alert('DEBUG: redirect auth')
        // console.log(router)
    }

    
    return null;
} 